import type { LoaderFunctionArgs } from 'react-router-dom'
import { generateOTP } from 'client/one-stop-checkin/one-stop-checkin.client'

export const tokenGeneratorLoader = async ({ params }: LoaderFunctionArgs) => {
  return await generateOTP(`${params.type}`)
}
